import React, { useEffect, useRef } from 'react';
import './ticker.css';

const LiveTicker = () => {
  const widgetRef = useRef(null);

  useEffect(() => {
    // Capture the ref value in a variable
    const currentRef = widgetRef.current;

    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-crypto-coins-heatmap.js';
    script.async = true;
    script.innerHTML = JSON.stringify({
      dataSource: 'Crypto',
      blockSize: 'market_cap_calc',
      blockColor: 'change',
      locale: 'en',
      symbolUrl: '',
      colorTheme: 'dark',
      hasTopBar: false,
      isDataSetEnabled: false,
      isZoomEnabled: false, // Disable zoom
      hasSymbolTooltip: true,
      isMonoSize: false,
      width: '100%',
      height: '100%',
    });

    if (currentRef) {
      currentRef.appendChild(script);
    }

    return () => {
      if (currentRef) {
        currentRef.innerHTML = '';
      }
    };
  }, []);

  return (
    <div id="tradingview-widget-container" className="widget-container">
      <div id="tradingview-widget" className="widget" ref={widgetRef}></div>
      <div id="tradingview-copyright" className="copyright">
        {/* <a href="https://www.tradingview.com/" rel="noopener nofollow" target="_blank">
          <span className="blue-text">Track all markets on TradingView</span>
        </a> */}
      </div>
    </div>
  );
};

export default LiveTicker;
